export default "__VITE_ASSET__BMnFmY4r__"